import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterTransactionsByPlayerFirstLevelReports from 'views/regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports'; // Importing filter component
import TableTransactionsByPlayerFirstLevelReports from 'views/regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports'; // Importing table component

/**
 * Class representing the view for transactions by player at the first level.
 * @extends JetView
 */
export default class TransactionsByPlayerFirstLevelView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        let vthis = this; // Reference to the current instance

        // Toolbar configuration
        const toolbar = {
            id: 'toolbar',
            view: 'toolbar',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger size change event
                        },
                    },
                },
                {
                    id: 'pagerA', // Pager component
                    view: 'pager',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                },
                {
                    id: 'Export', // Export dropdown
                    view: 'richselect',
                    name: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Localization for placeholder
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value === 1) {
                                // Excel export
                                let table = $$('datatable'); // Reference to the data table
                                for (let j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export data event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de ingreso del titular (Primer Nivel) (Deportivas) (8.7.2)'),
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de ingreso del titular (Primer Nivel) (8.7.2)'),
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reporte de ingreso del titular (Primer Nivel) (8.7.2)'),
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de ingreso del titular (Primer Nivel) (8.7.2)'),
                                        autowidth: true, // Auto width for PDF
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind context
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        {
                            css: 'int-left',
                            rows: [
                                {
                                    view: 'toolbar', // Toolbar for the report
                                    css: theme,
                                    elements: [
                                        {
                                            view: 'label',
                                            label: _(
                                                'Reporte transacciones realizadas por cada jugador (Deportivas) (8.7.7) Primer nivel',
                                            ), // Report title
                                        },
                                        {
                                            id: 'button-search', // Search button
                                            type: 'wide',
                                            css: 'close-bottom',
                                            cols: [
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-search', // Search icon
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () => {
                                                        $$('filterPopup').show(); // Show filter popup
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            type: 'wide',
                                            css: 'close-bottom',
                                            cols: [
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close', // Close icon
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () =>
                                                        this.show(
                                                            '/top/dashboard', // Navigate to dashboard
                                                        ),
                                                },
                                            ],
                                        },
                                    ],
                                },
                                FilterTransactionsByPlayerFirstLevelReports, // Filter component
                                TableTransactionsByPlayerFirstLevelReports, // Table component
                                toolbar, // Toolbar component
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
